import { render } from "./FPThreadsCard.vue?vue&type=template&id=4bb874b8&ts=true"
import script from "./FPThreadsCard.ts?vue&type=script&lang=ts&external"
export * from "./FPThreadsCard.ts?vue&type=script&lang=ts&external"

import "./FPThreadsCard.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__